module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmtitle1"
  }, [_c('a', {
    attrs: {
      "id": "h3"
    }
  }, [_vm._v("VISITING MILITARY CEMETERIES")])]), _c('a', {
    attrs: {
      "id": "h3"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The concept of the "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Imperial War Graves Commission (IWGC)")]), _vm._v(" was created by "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Major Fabian Ware")]), _vm._v(", the volunteer leader of a Red Cross mobile unit which saw service on the Western Front for most of the period of the war. Concern for the identification and burial of the dead led him to begin lobbying for an organization devoted to burial and maintenance of those who had been killed or died in the service of their country. On 21 May 1917 the Prince of Wales became the president of the IWGC with Fabian Ware (1869–1949) as its vice-chairman, forty-three years later this became the "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Commonwealth War Graves Commission (CWGC).")]), _vm._v(" Neither a soldier nor a politician, Ware was later honoured with a knighthood and held the honorary rank of major general. The commission was responsible for introducing the standardized headstone which, after the equality of sacrifice, would bring equality in death, regardless of rank, race or creed and it is this familiar white headstone that you will see now in CWGC cemeteries all over the world. In the area covered by this guidebook we have referred to and described forty-one cemeteries containing British and Commonwealth casualties and one French Communal Cemetery. CWGC cemeteries are usually well signposted with the familiar green and white direction indicators and where there is a CWGC plot within a communal cemetery, such as "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Festubert Communal Cemetery")]), _vm._v(", the familiar green and white sign at the entrance, with the words ‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tombes de Guerre du Commonwealth")]), _vm._v("’, will indicate their presence. The tall Cross of Sacrifice with the bronze Crusader’s sword can be found in many cemeteries, such as "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Guards Cemetery")]), _vm._v(", "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Windy Corner")]), _vm._v(", where there are relatively large numbers of dead. The larger cemeteries also have the rectangular shaped Stone of Remembrance. A visitor’s book and register of casualties is usually kept in the bronze box by the entrance but occasionally, as in "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Cuinchy")]), _vm._v(" and "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Bois-Grenier Communal Cemeteries,")]), _vm._v(" the register is kept separately next to the Cross of Sacrifice. Sadly, a number of registers have been stolen and to prevent this from happening you may find a cemetery register is now kept in the local "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mairie")]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fe48e81","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/05_fm02.vue
// module id = 72
// module chunks = 0